// Web replacement for react-native-geolocation-service.
// Same getCurrentPosition(success, error, options) shape as the native
// module, backed by the browser Geolocation API.
const Geolocation = {
  getCurrentPosition(success, error, options) {
    if (!navigator.geolocation) {
      error && error({ code: 2, message: 'Geolocation is not supported in this browser.' });
      return;
    }
    navigator.geolocation.getCurrentPosition(success, error, options);
  },
  watchPosition(success, error, options) {
    if (!navigator.geolocation) return -1;
    return navigator.geolocation.watchPosition(success, error, options);
  },
  clearWatch(watchId) {
    if (navigator.geolocation) navigator.geolocation.clearWatch(watchId);
  },
  stopObserving() {},
  requestAuthorization() {
    // Browsers show their own permission prompt on the first
    // getCurrentPosition/watchPosition call — nothing to request up front.
    return Promise.resolve('granted');
  },
};

export default Geolocation;
